import {
  defaultColor,
  defaultLinkColor,
} from 'presentations/views/styles/default';
import { css } from '@emotion/react';
import { fontSize, mediaMax } from '.';
import { Appearance, appearanceCacheKey, background, white } from './color';
import { getPersistentItem } from '../helpers/storage';

interface GlobalStyleProps {
  isDarkable: boolean;
  isLanding?: boolean;
}

const globalStyle = (props: GlobalStyleProps) => {
  const appearance = props.isLanding
    ? Appearance.Gray
    : (props.isDarkable && getPersistentItem(appearanceCacheKey)) ||
      Appearance.Normal;
  const themeProps = { theme: { appearance } };
  return css`
body {
  font-size: 14px;
  font-family: "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, -apple-system, BlinkMacSystemFont, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-overflow-scrolling: touch;
  -webkit-text-size-adjust: 100%;
  line-height: 1.6;
  color: ${defaultColor(themeProps)};
  letter-spacing: 0.05em;
  background-color: ${background(themeProps)};
  /* ${mediaMax.smartphone} {
    font-size: ${fontSize(12)};
  } */
}
a {
  text-decoration: none;
  color: ${defaultLinkColor(themeProps)};
}
h1, h2, h3, h4, h5, h6, p, pre, dd, figure, dl, ol, ul {
  margin-bottom: 0;
}
img { vertical-align:bottom; }
ol, ul {
  margin-top: 0;
  margin-bottom: 0;
  list-style: none;
}
textarea {
  line-height: 1.5;
}

*,
*:after,
*:before { box-sizing: border-box; }
`;
};

export default globalStyle;
